import { memo, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import dayjs from 'dayjs';
import { Form, FormCheck } from 'react-bootstrap';
import { PointerSpan } from '../../../../../CompUtils/PointerSpan';

type Props = {
  id: string;
  title: string;
  save: boolean;
  time?: boolean;
  values: any;
  setValues: any;
  clear: boolean;
  setClear: any;
};

const useClasses = createUseStyles({
  check: {
    verticalAlign: 'middle',
    textAlign: 'center',
  },
});

export const CronogramaFila = memo((props: Props) => {
  const { id, title, time, values, setValues } = props;
  const [datos, setDatos] = useState({ marcado: false, fFin: '', fInicio: '' });

  const { data } = useSelector((state: any) => state.cronograma);

  const last = [...(data || [])].reverse().find((e) => e.instancias === title);
  const { f_fin, f_inicio } = last || {};

  useEffect(() => {
    setDatos({
      marcado: f_fin ? true : false,
      fInicio: f_inicio,
      fFin: f_fin,
    });
  }, [last]);

  useEffect(() => {
    if (props.clear) {
      setDatos({
        marcado: false,
        fInicio: '',
        fFin: '',
      });
      props.setClear(false);
    }
  }, [props.clear]);

  /*   const isReadOnly = useCallback(
    (values: any): boolean => {
      return !values[`${id}_habilitar`];
    },
    [id],
  ); */

  /*   const validation = Yup.string().when(`${id}_habilitar`, {
    is: true,
    then: Yup.string().required('La fecha es obligatoria'),
  }); */

  useEffect(() => {
    if (props.save) {
      setValues((prev: any) => {
        let newValues = { ...prev };
        newValues[title] = datos;
        return newValues;
      });
    }
  }, [props.save]);

  const classes = useClasses();
  if (!data) return null;

  return (
    <tr>
      <td className={classes.check}>
        <FormCheck
          checked={datos.marcado}
          type="checkbox"
          onChange={() => {
            setDatos({
              ...datos,
              marcado: !datos.marcado,
            });
          }}
        />
        {/*         <RadioInput
          isCheckbox
          id={`${id}_habilitar`}
          initialValue={!!f_fin || !!f_inicio}
          onChange={(val, { setFieldValue, setFieldError }) => {
            if (!val) {
              setFieldValue(`${id}_f_fin`, '');
              setFieldValue(`${id}_f_inicio`, '');
              setFieldError(`${id}_f_fin`, '');
              setFieldError(`${id}_f_inicio`, '');
            }
          }}
        /> */}
      </td>
      <td>
        <PointerSpan
          onClick={() => {
            setDatos({
              ...datos,
              marcado: !datos.marcado,
            });
          }}>
          {title}
        </PointerSpan>
      </td>
      <td>
        <Form.Control
          type="date"
          disabled={!datos.marcado}
          value={datos.fInicio ? dayjs(datos.fInicio).format('YYYY-MM-DD') : ''}
          onChange={(e) => {
            setDatos({ ...datos, fInicio: e.target.value });
          }}
        />
      </td>
      <td>
        <Form.Control
          type="date"
          disabled={!datos.marcado}
          value={datos.fFin ? dayjs(datos.fFin).format('YYYY-MM-DD') : ''}
          onChange={(e) => {
            setDatos({ ...datos, fFin: e.target.value });
          }}
        />
      </td>
      {/*       <td>
        <DateInput
          initialValue={f_inicio}
          //readOnly={isReadOnly}
          id={`${id}_f_inicio`}
          datetime={time}
          validate={validation}
          validateTitle={`${title} 'Fecha Inicio'`}
        />
      </td>
      <td>
        <DateInput
          validate={validation}
          initialValue={f_fin}
          //readOnly={isReadOnly}
          id={`${id}_f_fin`}
          datetime={time}
          validateTitle={`${title} 'Fecha Fin'`}
        />
      </td> */}
    </tr>
  );
});
